export default __webpack_public_path__ + "static/img/putaway_module.96ba21a.svg";